<template>
	<div>
		<a-modal title="预约详情" :width="800" :visible="visible"  @cancel="handleCancel" >
			<!-- <template slot="footer" v-if="order.status==2">
				<a-button  key="back"  @click="cancelAppointAct" :loading="cancelAppointLoading">
					取消预约
				</a-button>
				<a-button  key="submit" type="primary" @click="sureAppointAct" :loading="sureAppointLoading">
					确认预约
				</a-button>
			</template> -->
			<template slot="footer">
				<a-button  key="back"  @click="handleCancel" >
					关闭弹窗
				</a-button>
			</template>

			<div class="item" v-for="(item,index) in order.items" :key="index" >
				<div class="flex space">
					<div>{{ getChineseNumber(index) }}</div>
					<div v-if="item.status==1"><a-button type="primary" icon="plus" @click="editAppointmentAct(item)">预约修改</a-button></div>
				</div>
				<a-divider />
				<a-spin :spinning="loading">
					<div class="pt24 pb24">
						<div class="flex alcenter space">
							<div class="flex alcenter">
								<img :src="item.project_cover_img" class="order-detail-project-cover-img"/>
								<div class="ml10">
									<div class="flex alcenter">
										<div class="ft14 ftw400 cl-black">{{item.project_name}}</div>
										<div class="order-detail-status-on ml8" v-if="item.status==1 || item.status==2 || item.status==4">{{item.status_means}}</div>
										<div class="order-detail-status-off ml8" v-if="item.status==6 || item.status==8">{{item.status_means}}</div>
									</div>
								</div>
							</div>
							
							<div class="flex alcenter">
								<div>预约时间：</div>
								<div class="flex alcenter ft14 ftwblod">
									<div class="cl-black">{{item.day}}</div>
									<div class="cl-theme ml4">{{item.start_time}}-{{item.end_time}}</div>
								</div>
							</div>
							
						</div>
					</div>
					
					<a-divider />
					
					<div class="pt24 pb24">
						<div class="flex space">
							<div>
								<div class="flex alcenter">
									<div class="ft14 ftw400 cl-info">预约编号：</div>
									<div class="ft14 ftwblod cl-black">{{item.appointment_item_id}}</div>
								</div>
								<div class="flex alcenter mt15">
									<div class="ft14 ftw400 cl-info">下单时间：</div>
									<div class="ft14 ftwblod cl-black">{{item.add_time_format}}</div>
								</div>
								<div class="flex alcenter mt15">
									<div class="ft14 ftw400 cl-info">现价：</div>
									<div class="ft14 ftwblod cl-black">{{item.current_price}}</div>
								</div>
							</div>
							
							<div>
								<div class="flex alcenter">
									<div class="ft14 ftw400 cl-info">预约用户：</div>
									<div class="ft14 ftwblod cl-black">{{item.member_name}}</div>
								</div>
								<div class="flex alcenter mt15">
									<div class="ft14 ftw400 cl-info">手机号码：</div>
									<div class="ft14 ftwblod cl-black">{{item.member_mobile}}</div>
								</div>
								<div class="flex alcenter mt15">
									<div class="ft14 ftw400 cl-info">折扣：</div>
									<div class="ft14 ftwblod cl-black">{{item.discount}}</div>
								</div>
							</div>
							
							<div>
								<div class="flex alcenter">
									<div class="ft14 ftw400 cl-info">预约技师：</div>
									<div class="ft14 ftwblod cl-black">{{item.technician_name}}</div>
								</div>
								<div class="flex alcenter mt15">
									<div class="ft14 ftw400 cl-info">手机号码：</div>
									<div class="ft14 ftwblod cl-black">{{item.technician_mobile}}</div>
								</div>
								<div class="flex alcenter mt15">
									<div class="ft14 ftw400 cl-info">实价：</div>
									<div class="ft14 ftwblod cl-black">{{Number(item.current_price * item.discount).toFixed(2)}}</div>
								</div>
							</div>
						</div>
					</div>
				
					<a-divider v-if="item.status==4" />
					
					<div class="pt24 pb24"  v-if="item.status==4">
						<div>
							<div class="flex alcenter">
								<div class="ft14 ftw400 cl-info">到店时间：</div>
								<div class="ft14 ftwblod cl-black">{{item.arrival_time_format}}</div>
							</div>
							<div class="flex alcenter mt15">
								<div class="ft14 ftw400 cl-info">操作人员：</div>
								<div class="ft14 ftwblod cl-black">{{item.operate_name}} {{item.operate_mobile}}</div>
							</div>
						</div>
					</div>
					
					<a-divider v-if="item.status==6" />
					
					<div class="pt24 pb24"  v-if="item.status==6">
						<div>
							<div class="flex alcenter">
								<div class="ft14 ftw400 cl-info">取消时间：</div>
								<div class="ft14 ftwblod cl-black">{{item.cancel_time_format}}</div>
							</div>
							<div class="flex alcenter mt15">
								<div class="ft14 ftw400 cl-info">操作人员：</div>
								<div class="ft14 ftwblod cl-black"> {{item.operate_name}} {{item.operate_mobile}}</div>
							</div>
							<div class="flex alcenter mt15">
								<div class="ft14 ftw400 cl-info">取消原因：</div>
								<div class="ft14 ftwblod cl-black">{{item.reason}}</div>
							</div>
						</div>
					</div>

					<a-divider v-if="item.status==8" />
					
					<div class="pt24 pb24"  v-if="item.status==8">
						<div>
							<div class="flex alcenter">
								<div class="ft14 ftw400 cl-info">爽约时间：</div>
								<div class="ft14 ftwblod cl-black">{{item.shuang_time_format}}</div>
							</div>
							<div class="flex alcenter mt15">
								<div class="ft14 ftw400 cl-info">操作人员：</div>
								<div class="ft14 ftwblod cl-black">{{item.operate_name}} {{item.operate_mobile}}</div>
							</div>
						</div>
					</div>

					<a-divider />

					<a-button  
						key="back"  
						type="primary" 
						@click="showCancelDialog(index)" 
						:loading="cancelAppointLoading" 
						v-if="item.status == 1"
						class="item_button">
						取消预约
					</a-button>

					<a-button  
						key="shuang"  
						type="primary" 
						@click="shuangWriteOffActItem(item.appointment_item_id)" 
						:loading="shuangWriteOffLoading" 
						v-if="item.status == 2"
						class="item_button">
						已爽约
					</a-button>

					<!-- 充值卡确认到店需要核销金额，去看板确认 -->
					<!-- <a-button  
						key="submit" 
						type="primary" 
						@click="sureWriteOffActItem(item.appointment_item_id)" 
						:loading="sureWriteOffLoading" 
						v-if="item.status == 2"
						class="item_button">
						确认到店
					</a-button> -->

					<!-- 为每个项目创建独立的弹窗 -->
					<div v-if="item.showCancelDialog">
						<cancel-appoint-item 
							:appointment_item_id="item.appointment_item_id" 
							:visible="item.showCancelDialog" 
							@cancel="cancelCancelAppointItem(index)" 
							@ok="okCancelAppointItem(index)">
						</cancel-appoint-item>
					</div>
				</a-spin>
			</div>
		</a-modal>

		<!-- 取消预约（父单） -->
		<!-- <div v-if="cancelAppointVisible">
			<cancel-appoint :appointment_id="order.appointment_id" :visible="cancelAppointVisible" @cancel="cancelCancelAppoint" @ok="okCancelAppoint"></cancel-appoint>
		</div> -->

		<!-- 预约修改 -->
		<div v-if="editAppointmentVisible">
			<edit-appointment :visible="editAppointmentVisible" @cancel="cancelEditAppointment" @ok="okEditAppointment" :item="editItem"></edit-appointment>
		</div>
	</div>
</template>

<script>
	import cancelAppoint from './detail/modal/cancelAppoint.vue';
	import cancelAppointItem from './detail/modal/cancelAppointItem.vue';
	import editAppointment from './editAppointment.vue';
	export default {
		props: {
			visible:{
				type:Boolean,
				default:false,
			},
			order:{
				type:Object,
				default:function(){
					return new Object;
				},
			}
		},
		components:{
			cancelAppoint,
			cancelAppointItem,
			editAppointment
		},
		data() {
			return {
				loading: false,
				cancelAppointLoading:false,
				sureAppointLoading:false,
				sureWriteOffLoading:false,
				cancelAppointVisible:false,
				shuangWriteOffLoading:false,
				editAppointmentVisible:false,
				editItem:{}
			}
		},
		created() {
			// 初始化时确保每个项目都有对应的状态字段
			this.order.items.forEach(item => {
				this.$set(item, 'showCancelDialog', false);
				this.$set(item, 'cancelLoading', false);
			});
		},
		methods: {
			getChineseNumber(num) {
				const chineseNumbers = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
				
				if (num < 10) {
					return `项目${chineseNumbers[num]}`;
				} else if (num < 20) {
					return `项目十${chineseNumbers[num - 10]}`;
				} else {
					// 对于更大的数字，可以扩展这个函数
					return `项目${num + 1}`;
				}
			},
			
			//取消预约（父单）
			cancelAppointAct(){
				this.cancelAppointVisible=true;
			},
			cancelCancelAppoint(){
				this.cancelAppointVisible=false;
			},
			okCancelAppoint(){
				this.cancelAppointVisible=false;
				this.$emit('cancelAppoint')
			},

			// 取消预约项（子单）, 显示取消对话框
			showCancelDialog(index) {
				this.$set(this.order.items[index], 'showCancelDialog', true);
				this.$set(this.order.items[index], 'cancelLoading', true);
			},
			cancelCancelAppointItem(index){
				this.$set(this.order.items[index], 'showCancelDialog', false);
      			this.$set(this.order.items[index], 'cancelLoading', false);
			},
			okCancelAppointItem(index){
				this.$set(this.order.items[index], 'showCancelDialog', false);
				this.$set(this.order.items[index], 'cancelLoading', false);
				
				// 重新获取订单数据
				this.getAppointmentDetail();
			},
			
			getAppointmentDetail(id){
				this.$http.api('admin/getAppointmentDetail',{
					appointment_id:this.order.appointment_id,
				}).then(res=>{
					this.$message.success('操作成功',1,()=>{
						console.log('res.data.detail',res)
						this.order = res.detail
					});
					
				}).catch(res=>{
					console.log(res);
				})
			},

			//确认预约（父单）
			sureAppointAct(){
				if(this.sureAppointLoading==true) return;
				this.sureAppointLoading=true;
				this.$http.api('admin/sureAppointment',{
					appointment_id:this.order.appointment_id,
				}).then(res=>{
					this.$message.success('操作成功',1,()=>{
						this.sureAppointLoading=false;
						this.$emit('sureAppoint')
					});
					
				}).catch(res=>{
					console.log(res);
					this.sureAppointLoading=false;
				})
			},
			
			//确认到店（父单）
			sureWriteOffAct(){
				if(this.sureWriteOffLoading==true) return;
				this.sureWriteOffLoading=true;
				this.$http.api('admin/arrivalAppointment',{
					appointment_id:this.order.appointment_id,
				}).then(res=>{
					this.$message.success('操作成功',1,()=>{
						this.sureWriteOffLoading=false;
						this.$emit('sureWriteOff')
					});
					
				}).catch(res=>{
					console.log(res);
					this.sureWriteOffLoading=false;
				})
			},

			//确认到店项（子单）
			sureWriteOffActItem(item_id){
				// 显示确认弹框
				this.$confirm({
					title: '确认到店',
					content: '确定要将此预约标记为已到店吗？',
					okText: '确认',
					cancelText: '取消',
					type: 'warning',
					onOk: () => {
						// 用户点击确认后执行的操作
						this.$http.api('admin/arrivalAppointmentItem',{
							appointment_item_id:item_id,
						}).then(res=>{
							this.$message.success('操作成功',1,()=>{
								
								// 重新获取订单数据
								this.getAppointmentDetail();
							});
							
						}).catch(res=>{
							console.log(res);
						})
					},
					onCancel: () => {
						// 用户点击取消，什么都不做
						console.log('用户取消操作');
					}
				});
			},

			// 已爽约（子单）
			shuangWriteOffActItem(item_id){
				// 显示确认弹框
				this.$confirm({
					title: '确认已爽约',
					content: '确定要将此预约标记为已爽约吗？',
					okText: '确认',
					cancelText: '取消',
					type: 'warning',
					onOk: () => {
						// 用户点击确认后执行的操作
						this.$http.api('admin/shuangAppointmentItem',{
							appointment_item_id:item_id,
						}).then(res=>{
							this.$message.success('操作成功',1,()=>{
								
								// 重新获取订单数据
								this.getAppointmentDetail();
							});
							
						}).catch(res=>{
							console.log(res);
						})
					},
					onCancel: () => {
						// 用户点击取消，什么都不做
						console.log('用户取消操作');
					}
				});
			},
			
			/**
			 * 取消弹窗
			 */
			handleCancel() {
				this.$emit("cancel");
			},

			// 预约修改
			editAppointmentAct(item){
				this.editItem = item
				this.editAppointmentVisible=true;
			},
			cancelEditAppointment(){
				this.editAppointmentVisible=false;
			},
			okEditAppointment(){
				this.editAppointmentVisible=false;
				// 重新获取订单数据
				this.getAppointmentDetail();
			},
	
		}
	}
</script>

<style>
	
	.order-detail-project-cover-img{
		width: 80px;
		height: 60px;
	}
	
	.order-detail-status-on{
		padding: 3px 8px;
		border-radius: 2px;
		border: 1px solid #4772FF;
		font-size: 14px;
		font-weight: 600;
		color: #4772FF;
	}
	
	.order-detail-status-off{
		padding: 3px 8px;
		border-radius: 2px;
		border: 1px solid #EBEDF5;
		font-size: 14px;
		font-weight: 600;
		color: #A6AEC2;
	}

	.item {
		margin-bottom: 30px;
		padding: 15px;
		border: 1px solid #999;   /* 很浅的灰色#e0e0e0 中等灰色#999 深灰色#666 */
	
	}

	.item_button {
		margin-right: 15px;
	}
</style>
